module.exports = __webpack_public_path__ + "static/media/iStock-587551046.73d8cb2d.jpg";